export default {
  items: [
    {
      name: 'Reports',
      url: '/reports',
      icon: 'icon-speedometer',
    },
    {
      name: 'Search',
      url: '/reports/search',
      icon: 'icon-drop',
    },
    {
      name: 'Edit',
      url: '/reports/edit',
      icon: 'icon-drop',
    },
    {
      name: 'Export CSV',
      url: '/reports/csv',
      icon: 'icon-drop',
    },
    {
      name: 'Batch Find',
      url: '/reports/prefixscan',
      icon: 'icon-drop',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/NavBar/_nav.js